<template>
  <div class="popup set-price" ref="space" @click="handleParentClick($event, 1)">
    <div class="content" ref="content" @click="handleParentClick($event, 2)">
      <div class="content-wrapper">
        <div class="price-title-wrapper">
          <p :class="(mode === 'basic-setting') ? 'title' : 'title title-off'" @click="setBasicMode">基本設定</p>
          <p :class="(mode === 'price-setting') ? 'title' : 'title title-off'" @click="setPriceMode">単価設定</p>
        </div>
        <div v-show="mode === 'basic-setting'" class="basic-setting">
          <div class="card-wrapper">
            <factory-card
              v-show="!editCard"
              :name="factory_profile.name"
              :logo="factory_logo"
              :location="factory_profile.address"
              :website="factory_profile.website"
              :pictures="factory_pics"
              service=""
              material=""
              :introduction="factory_profile.description"
              @editCard="setEditCard"
            />
            <factory-card-edit 
              v-show="editCard"
              :name="factory_profile.name"
              :logo="factory_logo"
              :pictures="factory_pics"
              :location="factory_profile.address"
              :postal="factory_profile.postal_code"
              :googleMapUrl="factory_profile.location"
              :website="factory_profile.website"
              :description="factory_profile.description"
              @cancelCardEdit="cancelCardEdit"
              @saveCardEdit="onSaveCardEdit"
            />
          </div>
          <div class="invoice-wrapper">
            <label for="invoice">インボイス登録番号</label>
            <input name="invoice" type="text" placeholder="T1234567891234" v-model="factory_setting.invoice_registration_number">
          </div>
        </div>

        <div v-show="mode === 'price-setting'" class="price-setting">
          <p class="section-title">加工単価</p>
          <div class="manufacturing-items-wrapper">
            <div class="manufacturing-item">
              <p>加工費</p>
              <div class="manufacturing-inputs-wrapper">
                <div class="manufacturing-input-group">
                  <label for=""></label>
                  <input type="text" v-model="manufacturing_costs.cutting_cost">
                  <span>円/時間</span>
                </div>
              </div>
            </div>

            <div class="manufacturing-item disabled-block">
              <p>面取り</p>
              <div class="manufacturing-inputs-wrapper">
                <div class="manufacturing-input-group">
                  <input type="checkbox" :checked="manufacturing_costs.is_edge_chamfering_enabled" ref="is_edge_chamfering_enabled" @change="updateBoolean('is_edge_chamfering_enabled')"/>
                  <label for="mentori-1">糸面取り</label>
                  <input type="text" name="mentori-1" v-model="manufacturing_costs.edge_chamfering_cost">
                  <span>円/m</span>
                </div>
                <div class="manufacturing-input-group">
                  <input type="checkbox" :checked="manufacturing_costs.is_r6mm_chamfering_enabled" ref="is_r6mm_chamfering_enabled" @change="updateBoolean('is_r6mm_chamfering_enabled')"/>
                  <label for="mentori-2">R面取り（6mm）</label>
                  <input type="text" name="mentori-2" v-model="manufacturing_costs.r6mm_chamfering_cost">
                  <span>円/m</span>
                </div>
                <div class="manufacturing-input-group">
                  <input type="checkbox" :checked="manufacturing_costs.is_r9mm_chamfering_enabled" ref="is_r9mm_chamfering_enabled" @change="updateBoolean('is_r9mm_chamfering_enabled')"/>
                  <label for="mentori-3">R面取り（9mm）</label>
                  <input type="text" name="mentori-3" v-model="manufacturing_costs.r9mm_chamfering_cost">
                  <span>円/m</span>
                </div>
              </div>
            </div>
            
            <div class="manufacturing-item">
              <p>仕上げ費</p>
              <div class="manufacturing-inputs-wrapper">
                <div class="manufacturing-input-group">
                  <input type="checkbox" :checked="manufacturing_costs.is_burr_enabled" ref="is_burr_enabled" @change="updateBoolean('is_burr_enabled')"/>
                  <label for="finish-1">バリ取り</label>
                  <span>加工時間 ×</span>
                  <input type="text" name="finish-1" v-model="manufacturing_costs.burr_cost">
                  <span>円/分</span>
                </div>
                <div class="manufacturing-input-group">
                  <input type="checkbox" :checked="manufacturing_costs.is_burr_sanding_enabled" ref="is_burr_sanding_enabled" @change="updateBoolean('is_burr_sanding_enabled')"/>
                  <label for="finish-2">バリ取り+表面研磨</label>
                  <span>加工時間 ×</span>
                  <input type="text" name="finish-2" v-model="manufacturing_costs.burr_sanding_cost">
                  <span>円/分</span>
                </div>
              </div>
            </div>
          </div>

          <p class="section-title">材料単価<span>最終更新 23年12月14日</span></p>
          <div class="material-items-wrapper">
            <p class="material-category">36板</p>
            <ul class="material-card-wrapper">
              <li v-for="(item, index) in materials36" :key="index">
                <material-card
                  :name="item.name"
                  :thumbnail="item.thumbnail"
                  :matArr="item.assortments"
                  @materialUpdate="onMaterialUpdate"
                />
              </li>
            </ul>
            <p class="material-category">48板</p>
            <ul class="material-card-wrapper">
              <li v-for="(item, index) in materials48" :key="index">
                <material-card
                  :name="item.name"
                  :thumbnail="item.thumbnail"
                  :matArr="item.assortments"
                  @materialUpdate="onMaterialUpdate"
                />
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="bottom-section">
        <div class="button-group">
          <a class="button grey-button" @click.prevent.stop="$emit('closeSetPricePopup')">
            <span>キャンセル</span>
          </a>
          <a class="button green-button" @click.prevent.stop='save'>
            <span>保存する</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Auth, Hub, Storage } from 'aws-amplify';
import PopupBase from "./PopupBase.vue";

import FactoryCard from "./FactoryCard.vue";
import FactoryCardEdit from "./FactoryCardEdit.vue";
import MaterialCard from "./MaterialCard.vue";

export default {
  name: "CalculatePopup",
  extends: PopupBase,
  components: {
    FactoryCard,
    FactoryCardEdit,
    MaterialCard,
  },

  data () {
    return { 
      mode: "basic-setting",
      // editCard: false,
      factory_1: require('../assets/images/factory_1.png'),
    };
  },

  props: {
    editCard: Boolean,
    manufacturing_costs: {},
    factory_logo: '',
    factory_pics: Array,
    factory_profile: {},
    factory_setting: {},
    materials36: Array,
    materials48: Array,
  },

  watch: {
    mode: (value) => {
      let categories = document.querySelector('.price-title-wrapper');
      switch (value) {
        case 'basic-setting':
          categories.style.setProperty('--pseudo-element-translateX', '0px');
          break;
        case 'price-setting':
          categories.style.setProperty('--pseudo-element-translateX', '95px');
          break;
      }

    }
  },

  mounted () {
    // this.$nextTick(() => {
      // this.$forceUpdate();
      // document.querySelector('.my-carousel').click();
    // });
  },

  computed: {
    rough_price: function () {
      let price_array = this.calculateContents.map((content) => {return content.total_price});
      return price_array.reduce((acc, cur) => acc+ cur, 0);
    },
    total_tax: function () {
      return Math.ceil(this.rough_price * 0.1);
    },
    total_price: function () {
      return this.rough_price + this.total_tax;
    },
  },

  methods: {
    handleParentClick(event, num) {
      // writing 'click.prevent.stop' directly in the parent div will cause no-function checkbox.
      if (event.target.type !== 'checkbox' && event.target.type !== 'file') {
        event.preventDefault();
        event.stopPropagation();
        if (num === 1) {
          this.$emit('closeSetPricePopup');
        }
      }
    },
    setBasicMode () {
      this.mode = 'basic-setting';
    },
    setPriceMode () {
      this.mode = 'price-setting';
    },
    setEditCard () {
      // this.editCard = true;
      this.$emit('editCard');
    },
    cancelCardEdit () {
      // this.editCard = false;
      this.$emit('cancelEditCard');
    },
    onMaterialUpdate (updatedItem) {
      this.$emit('materialUpdate', updatedItem);
    },
    updateBoolean (updatedItem) {
      this.manufacturing_costs[updatedItem] = this.$refs[updatedItem].checked;
    },
    async onSaveCardEdit (profile) {
      this.$emit('saveFactoryProfile', profile);
      // this.editCard = false;
    },
    async save () {
      this.$emit('saveSetting', this.mode, (this.mode === "price-setting") ? this.manufacturing_costs : (this.mode === "basic-setting") ? this.factory_setting : null);
    }
  },
};
</script>

<style lang="scss" scoped>
:root {
  --pseudo-element-translateX: 0px;
}
.set-price {
  .content {
    width: 900px;
    // height: fit-content;
    max-height: 700px;
    height: 700px;
    // overflow-y: scroll;
    overflow: hidden;
    border-radius: 20px;
    font-size: 12px;
    font-weight: bold;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: start;

    // background-color: rgba($color: #ffffff, $alpha: 1.0);
    background-color: rgba($color: #eeeeee, $alpha: 1.0);
    padding: 2rem 20px;
    position: relative;

    .content-wrapper {
      width: 850px;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: end;
      // justify-content: end;
      height: calc(700px - 2rem - 80px);
      overflow-y: scroll;
      padding: 0 2rem;

      .price-title-wrapper {
        width: 100%;
        display: flex;
        position: relative;
        margin-top: .5rem;
        .title {
          font-size: 20px;
          margin-bottom: 2rem;
          margin-right: 1rem;
          cursor: pointer;
        }

        .title-off {
          opacity: .5;
        }

        &::before {
          content: '';
          position: absolute;
          width: 80px;
          height: 5px;
          background-color: #1bffc6;
          border-radius: 99em;
          bottom: 1.2rem;
          transform: translateX(var(--pseudo-element-translateX));
          transition: all ease .2s;
        }
      }

      .basic-setting {
        display: flex;
        width: 100%;
        align-items: start;
        justify-content: center;
        margin-bottom: 3rem;

        // .card-wrapper {}

        .invoice-wrapper {
          background-color: #fff;
          padding: 1rem;
          border-radius: 10px;
          margin-left: 2rem;

          // label {}

          input {
            background-color: #EEEEEE;
            width: 150px;
            height: 2rem;
            margin-left: 1rem;
            border-radius: 10px;
            padding: 5px 10px;
          }
        }
      }

      .price-setting {
        width: 100%;

        .section-title {
          font-size: 20px;
          margin-bottom: 1rem;
          span {
            font-size: 12px;
            margin-left: 1rem;
          }
        }

        .disabled-block {
          position: relative;
          &::before {
            content: '';
            position: absolute;
            width: 300px;
            height: 150px;
            background-color: rgba(0, 0, 0, .1);
            top: -20px;
            left: -10px;
            border-radius: 10px;
          }
          &::after {
            content: '* 近日追加予定';
            position: absolute;
            font-weight: 100;
            top: -15px;
          }
        }

        .manufacturing-items-wrapper {
          width: 100%;
          height: fit-content;
          padding: 2rem;
          background-color: #fff;
          border-radius: 10px;
          position: relative;
          display: flex;
          flex-wrap: wrap;
          margin-bottom: 2rem;
          .manufacturing-item {
            display: flex;
            align-items: start;
            width: 50%;
            p {
              transform: translateY(10px);
            }

            .manufacturing-inputs-wrapper {
              margin-left: 1rem;
              .manufacturing-input-group {
                margin-bottom: .5rem;
                display: flex;
                align-items: center;
                justify-content: start;

                input[type=checkbox] {
                  margin-right: 5px;
                }
                input[type=checkbox]:checked {
                  background-color: #1bffc6;
                }

                label {
                  margin-right: .5rem;
                }
                input[type=text] {
                  background-color: #eeeeee;
                  padding: 5px 10px;
                  border-radius: 10px;
                  width: 50px;
                  height: 35px;
                }
                span {
                  font-size: 10px;
                  margin-left: 5px;
                }
              }
            }
          }
        }

        .material-items-wrapper {
          width: 100%;
          height: fit-content;
          padding: 2rem;
          background-color: #fff;
          border-radius: 10px;
          position: relative;
          margin-bottom: 1rem;

          .material-category {
            width: 100%;
            background-color: #eeeeee;
            border-radius: 10px;
            padding: .5rem;
          }

          .material-card-wrapper {
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            margin-bottom: 1rem;
          }
        }
      }
    }

    .bottom-section {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: end;
      position: absolute;
      bottom: 0;
      height: 80px;
      border-top: 1px #000 solid;
      background-color: #fff;
      .button-group {
        display: flex;
        margin-right: 3rem;
        .button {
          display: flex;
          align-items: center;
          box-sizing: border-box;

          // color: white;
          // background: #00939D;
          color: #000;
          background: #1bffc6;
          border-radius: 99em;
          width: fit-content;
          height: 45px;
          margin-left: 1rem;
          margin-right: 0;

          padding: 0px 15px;

          font-style: normal;
          font-weight: bold;
          font-size: 14px;
          line-height: 1;

          overflow: hidden;

          img, span {
            display: inline-block;
            z-index: 2;
          }

          img {
            margin-right: 10px;
          }

        }

        .green-button {
          position: relative;
          &::before {
            content: '';
            position: absolute;
            background-color: #1be0a8;
            top: 0;
            left: auto;
            right: 0;
            width: 0;
            height: 100%;
            transition-duration: .5s;
            transition-timing-function: cubic-bezier(.075,.82,.165,1);
            z-index: 1;
          }

          &:hover{
            &::before {
              width: 100%;
              left: 0;
              right: auto;
            }
          }
        }

        .grey-button {
          background: #EEEEEE;
          // border: #000 1px solid;
        }
      }
    }
    
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SetPricePopup.vue